import PropTypes from 'prop-types';
import CombinationOddsPopupImpl from './combination-odds-popup.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * CombinationOddsPopup view: It should be visible for virtuals to have a look at the combination odds for Forecast and Tricast before placing a bet.
 *
 * @class CombinationOddsPopup
 * @public
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * CombinationOddsPopup prop types.
 *
 * @property {boolean} isVisible - The flag to determine if show/hide combination odds popup should be shown or not.
 * @property {Mojito.Services.Betslip.types.Part} parts - The bet's event all runners.
 * @property {Mojito.Services.Betslip.types.OddsLine[]} oddsLines - The combination multicast odds.
 * @property {string} headerTitle - The cast market name uses for popup header title.
 * @property {Function} [onClickOutside = ()=>{}] - Callback to invoke when clicking outside the popup.
 * @property {Function} [onCloseButtonClick = ()=>{}] - Callback to invoke when clicking the close button. If not provided no close button will be shown.
 *
 * @memberof Mojito.Modules.Betslip.BetslipView.CombinationOddsPopup
 */
const propTypes = {
    isVisible: PropTypes.bool.isRequired,
    parts: PropTypes.array.isRequired,
    oddsLines: PropTypes.array.isRequired,
    headerTitle: PropTypes.string,
    onClickOutside: PropTypes.func,
    onCloseButtonClick: PropTypes.func,
};

const defaultProps = {
    headerTitle: '',
    onClickOutside: noop,
    onCloseButtonClick: noop,
};

export default UIView('CombinationOddsPopup', CombinationOddsPopupImpl, propTypes, defaultProps);
